import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { auth, db } from "./firebase";
import { addDoc, collection } from "firebase/firestore";
import './App.css';
import '../src/components/CartOffcanvas/CartOffcanvas.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Service from './components/Services/Service';
import Electrician from './components/Electrician/Electrician';
import Plumber from './components/Plumber/Plumber';
import Fridge from './components/Fridge/Fridge';
import Washing from './components/Washing/Washing';
import ACMachine from './components/ACMachine/ACMachine';
import Carpenter from './components/Carpenter/Carpetner';
import Footer from './components/Footer/Footer';
import Payment from './components/Payment/Payment';
import Cctv from './components/CCTV/Cctv';
import CartOffcanvas from "./components/CartOffcanvas/CartOffcanvas";
import Customer from "./components/Customer/Customer";
import BottomCart from "./components/BottomCart/BottomCart";
import Cooler from "./components/Cooler/Cooler";
import Loader from "./components/Loader/Loader";
import Laundry from "./components/Laundry/Laundry";
import Search from "./components/SearchBar/Search";
function App() {
  const [redirectAfterLogin, setRedirectAfterLogin] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showWebsiteReview, setShowWebsiteReview] = useState(false);
  const [rating, setRating] = useState(3);
  const [comment, setComment] = useState("");

  useEffect(() => {

    const timer = setTimeout(() => {
      setShowWebsiteReview(true);
    }, 180000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  }, []);
  const addToCart = (service) => {
    setCart((prevCart) => {
      const exists = prevCart.some(
        (item) => item.id === service.id
      );

      if (exists) return prevCart;

      return [...prevCart, service];
    });
  };
  const removeFromCart = (indexToRemove) => {
    setCart(prevCart =>
      prevCart.filter((_, index) => index !== indexToRemove)
    );
  };

  const submitWebsiteReview = async () => {

    if (!auth.currentUser) {
      alert("Please login to submit review");
      return;
    }

    await addDoc(collection(db, "reviews"), {
      userId: auth.currentUser.uid,
      type: "website",
      review: comment,
      rating: rating,
      createdAt: new Date()
    });

    setShowWebsiteReview(false);
  };

  if (loading) {
    return <Loader />;
  }
  const getProgressColor = () => {
    const percent = ((rating - 1) / 4) * 100;

    if (percent <= 20) return "bg-danger";
    if (percent <= 40) return "bg-warning";
    if (percent <= 60) return "bg-info";
    if (percent <= 80) return "bg-primary";
    return "bg-success";
  };
  const handleDrag = (e) => {
    const bar = e.currentTarget;

    const updateRating = (clientX) => {
      const rect = bar.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;

      percent = Math.max(0, Math.min(100, percent));

      const newRating = Math.round((percent / 100) * 4) + 1;
      setRating(newRating);
    };

    const onMove = (e) => updateRating(e.clientX);
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);

    updateRating(e.clientX);
  };


  const handleTouch = (e) => {
    const bar = e.currentTarget;

    const updateRating = (clientX) => {
      const rect = bar.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;

      percent = Math.max(0, Math.min(100, percent));

      const newRating = Math.round((percent / 100) * 4) + 1;
      setRating(newRating);
    };

    const onMove = (e) => updateRating(e.touches[0].clientX);
    const onEnd = () => {
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onEnd);
    };

    window.addEventListener("touchmove", onMove);
    window.addEventListener("touchend", onEnd);

    updateRating(e.touches[0].clientX);
  };
  return (


    <Router>
      <Navbar
        cartCount={cart.length}
        showModal={showModal}
        setShowModal={setShowModal}
        redirectAfterLogin={redirectAfterLogin}
        setRedirectAfterLogin={setRedirectAfterLogin}
      />
      <CartOffcanvas
        cart={cart}
        removeFromCart={removeFromCart}
      />
      <Routes>

        <Route
          path="/"
          element={
            <>
              <Hero />
              <Search />
              <Service />
              <Footer />
            </>
          }
        />
        <Route
          path="/laundry"
          element={
            <Laundry cart={cart} addToCart={addToCart} />
          }
        />
        <Route
          path="/electrician"
          element={
            <Electrician cart={cart} addToCart={addToCart} />
          }
        />

        <Route
          path="/acmachine"
          element={
            <ACMachine cart={cart} addToCart={addToCart} />
          }
        />

        <Route
          path="/fridge"
          element={
            <Fridge cart={cart} addToCart={addToCart} />
          }
        />

        <Route
          path="/plumber"
          element={
            <Plumber cart={cart} addToCart={addToCart} />
          }
        />

        <Route
          path="/washing"
          element={
            <Washing cart={cart} addToCart={addToCart} />
          }
        />

        <Route
          path="/carpenter"
          element={
            <Carpenter cart={cart} addToCart={addToCart} />
          }
        />
        <Route
          path="/cctv"
          element={
            <Cctv cart={cart} addToCart={addToCart} />
          }
        />
        <Route
          path="/cooler"
          element={
            <Cooler cart={cart} addToCart={addToCart} />
          }
        />
        <Route
          path="/payment"
          element={
            <Payment
              cart={cart}
              openLoginModal={(redirect = false) => {
                setRedirectAfterLogin(redirect);
                setShowModal(true);
              }}
            />
          }
        />
        <Route path="/customer" element={<Customer />} />

      </Routes>
      <BottomCart cart={cart} />

      {showWebsiteReview && (
        <div className="modal-overlay">
          <div className="modal-box text-center">
            <h5>Rate your experience! 👋</h5>
            <p>How was your experience using QuickSeva?</p>
            <div style={{ fontSize: "40px" }}>
              {{
                1: "😡",
                2: "😕",
                3: "🙂",
                4: "😊",
                5: "😍",
              }[rating || 3]}
            </div>
            <p style={{ fontWeight: "500" }}>
              {{
                1: "Poor",
                2: "Fair",
                3: "Good",
                4: "Very Good",
                5: "Excellent",
              }[rating || 3]}
            </p>
            <div
              className="progress mt-3 draggable-bar"
              style={{ height: "10px", cursor: "pointer" }}
              onMouseDown={handleDrag}
              onTouchStart={handleTouch}
            >
              
              <div
                className={`progress-bar progress-bar-striped progress-bar-animated ${getProgressColor()}`}
                style={{ width: `${((rating - 1) / 4) * 100}%` }}
              ></div>
            </div>
            <textarea
              className="form-control mt-3"
              placeholder="Any comment for us?"
              onChange={(e) => setComment(e.target.value)}
            />
            <button
              className="btn btn-primary w-100 mt-3"
              onClick={submitWebsiteReview}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-secondary w-100 mt-2"
              onClick={() => setShowWebsiteReview(false)}
            >
              Close
            </button>

          </div>
        </div>
      )}
    </Router>
  );
}

export default App;
